import React, { useState } from 'react';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: 'İK Departmanı',
      text: 'Merhaba! Size nasıl yardımcı olabilirim?',
      time: '14:30',
      isSystem: true
    },
    {
      id: 2,
      sender: 'Ben',
      text: 'İzin talebimin durumu nasıl?',
      time: '14:32',
      isSystem: false
    },
    {
      id: 3,
      sender: 'İK Departmanı',
      text: 'İzin talebiniz değerlendiriliyor. Yarın size dönüş yapacağız.',
      time: '14:35',
      isSystem: true
    }
  ]);

  const handleSendMessage = () => {
    if (message.trim()) {
      const newMessage = {
        id: messages.length + 1,
        sender: 'Ben',
        text: message,
        time: new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
        isSystem: false
      };
      setMessages([...messages, newMessage]);
      setMessage('');
      
      // Simulate reply
      setTimeout(() => {
        const replyMessage = {
          id: messages.length + 2,
          sender: 'İK Departmanı',
          text: 'Mesajınızı aldık. En kısa sürede size dönüş yapacağız.',
          time: new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
          isSystem: true
        };
        setMessages(prev => [...prev, replyMessage]);
      }, 1000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (

      <div className="chat-widget">
        {/* Chat Window */}
        {isOpen && (
          <div className={`chat-window ${isOpen ? 'show' : ''}`}>
            {/* Header */}
            <div className="chat-header">
              <div style={{ flexGrow: 1 }}>
                <h6 className="mb-0">Destek Chat</h6>
                <small>İK Departmanı</small>
              </div>
              <button 
                className="btn btn-link text-white p-0"
                onClick={() => setIsOpen(false)}
                style={{ background: 'none', border: 'none', color: 'white' }}
              >
                <i className="bx bx-x"></i>
              </button>
            </div>

            {/* Messages */}
            <div className="chat-messages">
              {messages.map(msg => (
                <div key={msg.id} className={`message ${msg.isSystem ? 'system' : 'user'}`}>
                  <div>{msg.text}</div>
                  <div className="message-time">{msg.time}</div>
                </div>
              ))}
            </div>

            {/* Input */}
            <div className="chat-input">
              <input
                type="text"
                placeholder="Mesajınızı yazın..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <button onClick={handleSendMessage}>
                <i className="bx bx-send"></i>
              </button>
            </div>
          </div>
        )}

        {/* Toggle Button */}
        <button 
          className="chat-toggle"
          onClick={() => setIsOpen(!isOpen)}
        >
          <i className={`bx ${isOpen ? 'bx-x' : 'bx-chat'}`}></i>
        </button>
      </div>
  );
};

export default ChatWidget; 